import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'device-service-portal';

  constructor(
    public translate: TranslateService
  ) {
    translate.addLangs(['en', 'nl']);
    translate.setDefaultLang('en');
    let browserLanguage = navigator.language;

    if(browserLanguage.startsWith("en")){     
      this.translate.use("en");
    } else if(browserLanguage.startsWith("fr")){
      this.translate.use("fr");
    } else if(browserLanguage.startsWith("nl")){
      this.translate.use("nl");
    }

    
    
  }
}
